module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 43
// module chunks = 0